import React from 'react';
import { Crown, Star, UserCheck } from 'lucide-react';

interface DecisionMakerBadgeProps {
  level: 'c-suite' | 'executive' | 'manager';
  count?: number;
  compact?: boolean;
}

const DecisionMakerBadge: React.FC<DecisionMakerBadgeProps> = ({ level, count, compact = false }) => {
  const getBadgeConfig = () => {
    switch (level) {
      case 'c-suite':
        return {
          icon: Crown,
          label: compact ? 'C-Suite' : 'C-Suite',
          bgColor: 'bg-purple-50',
          textColor: 'text-purple-700',
          borderColor: 'border-purple-200',
        };
      case 'executive':
        return {
          icon: Star,
          label: compact ? 'Exec' : 'Executive',
          bgColor: 'bg-blue-50',
          textColor: 'text-blue-700',
          borderColor: 'border-blue-200',
        };
      case 'manager':
        return {
          icon: UserCheck,
          label: compact ? 'Mgr+' : 'Manager+',
          bgColor: 'bg-emerald-50',
          textColor: 'text-emerald-700',
          borderColor: 'border-emerald-200',
        };
    }
  };

  const config = getBadgeConfig();
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${config.bgColor} ${config.textColor} ${config.borderColor}`}
      title={`${config.label}${count ? ` (${count})` : ''}`}
    >
      <Icon className="w-3 h-3" />
      {compact ? (
        <span className="font-semibold">{count || ''}</span>
      ) : (
        <>
          <span>{config.label}</span>
          {count && <span className="font-semibold">({count})</span>}
        </>
      )}
    </span>
  );
};

export default DecisionMakerBadge;
